export function scrollToElement(element, behavior = 'smooth', offset = 0) {
  let top = element.getBoundingClientRect().top;
  top -= document.body.getBoundingClientRect().top;
  top -= offset;
  window.scrollTo({ behavior, top });
}
